import { DislikeIcon, LikeFullIcon } from '@/assets/icons';
import styles from './buttons-like-and-dislike.module.scss';
import React from 'react';
import clsx from 'clsx';
import { useSwipedChange } from '@/store/useSwipedChange';

interface Props {
    visible?: boolean;
    customClass?: string;
    style?: React.CSSProperties;
    onSwipeLeft: () => void;
    onSwipeRight: () => void;
}

export const ButtonsLikeAndDislike: React.FC<Props> = ({ onSwipeLeft, onSwipeRight, visible, customClass, style, }) => {
    const dir = useSwipedChange((state) => state.dir);
    
    return (
        <div className={clsx(styles.wrapper, customClass)} {...(style && { style })}>
            <button
                className={clsx(
                    styles.button,
                    styles.left,
                    visible && styles.visible,
                    dir === 'left' && !!dir && styles.active,
                )}
                onClick={onSwipeLeft}>
                <DislikeIcon
                    width={72}
                    height={72} />
            </button>
            <button
                className={clsx(
                    styles.button,
                    styles.right,
                    visible && styles.visible,
                    dir === 'right' && !!dir && styles.active,
                )}
                onClick={onSwipeRight}>
                <LikeFullIcon
                    width={72}
                    height={72} />
            </button>
        </div>
    );
};
